export const _setStudentProfileLiveCourseData = (state, action) => {
  const { studentId, data } = action.payload;

  state.byStudentId[studentId] = {
    ...data,
    loaded: true,
    lastFetched: Date.now(),
  };
};
